export default __webpack_public_path__ + "static/media/dropmenu.99d8dfdd.svg";